











































































import {Component, Vue} from 'vue-property-decorator';
import {ExportField} from '@/models/ExportField';
import FileDownload from 'js-file-download';

@Component
export default class Export extends Vue {
    private uploadError: string = '';
    private exportError: string = '';
    private exportLoading: boolean = false;
    private uploadLoading: boolean = false;
    private fileInput: FileList|null = null;
    private tableHeaders: object[] = [
        { text: '#', value: 'index' },
        { text: 'Label', value: 'label' },
        { text: 'Include', value: 'include', align: 'center' },
    ];
    private exportModel: ExportField[] = [];
    private timestamp = new Date().getTime();
    public get canExport() {
        return this.exportModel.length > 0 && this.fileInput;
    }
    public reset(): void {
        this.fileInput = null;
        this.exportModel = [];
        this.timestamp = new Date().getTime();
    }
    public created(): void {
        const test = localStorage.getItem('test');
        if (test) {
            // this.exportModel = JSON.parse(test);
        }
    }
    public async onFileInput(event: any): Promise<void> {
        this.timestamp = new Date().getTime();
        const fileInput = event.target.files;
        if (this.uploadLoading) {
            return;
        }
        const file: File = fileInput?.item(0) as File;
        if (!file) {
            return;
        }
        this.fileInput = fileInput;
        const formData = new FormData();
        formData.append('files', file);
        try {
            this.exportModel = [];
            this.uploadError = '';
            this.uploadLoading = true;
            const { data } = await this.axios.post('/api/preview', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            this.exportModel = data;
            localStorage.setItem('test', JSON.stringify(data));
        } catch (error) {
            this.uploadError = error.response.data.detail;
        }
        this.uploadLoading = false;
    }
    public async fetchExport(): Promise<void> {
        if (!this.fileInput) {
            return;
        }
        if (this.exportLoading) {
            return;
        }
        const file: File = this.fileInput?.item(0) as File;
        if (!file) {
            return;
        }
        const formData = new FormData();
        formData.append('fields', JSON.stringify(this.exportModel));
        formData.append('files', file);
        try {
            this.exportError = '';
            this.exportLoading = true;
            const { data } = await this.axios.post('/api/export', formData, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            FileDownload(data, file.name + '.xlsx');
        } catch (error) {
            this.exportError = error.response.data.detail;
        }
        this.exportLoading = false;
    }
}
